/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ToggleUserLoyaltyRequest } from '../../models/toggle-user-loyalty-request';
import { ToggleUserLoyaltyResult } from '../../models/toggle-user-loyalty-result';

export interface PostToggleLoyalty$Params {
  body?: ToggleUserLoyaltyRequest;
}

export function postToggleLoyalty(
  http: HttpClient,
  rootUrl: string,
  params?: PostToggleLoyalty$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ToggleUserLoyaltyResult>> {
  const rb = new RequestBuilder(rootUrl, postToggleLoyalty.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ToggleUserLoyaltyResult>;
    }),
  );
}

postToggleLoyalty.PATH = '/Loyalty/toggle-loyalty';
